module.exports = __webpack_public_path__ + "entry-41b28522/carola-ludewig-photo-62028cde65050610c3e870975425861d.webp";